import axios from 'axios'
import config from '@/config'
import {isFailed} from '@/shared/api.utils'
import router from '@/router'

const tokenKey = 'carrierToken'
const loginModule = {
  namespaced: true,
  state: {
    token: localStorage.getItem(tokenKey),
  },
  mutations: {
    updateToken (state, payload) {
      if (payload) {
        localStorage.setItem(tokenKey, payload)
        state.token = payload
      } else {
        localStorage.removeItem(tokenKey)
        state.token = null
      }
    },
  },
  actions: {
    logout: function (context, payload) {
      console.log('logout...')
      context.commit('shared/updateUser', null, {root: true})
      context.commit('updateToken', null)
      router.push({name: 'login'})
    },
    auth: function (context, payload) {
      console.log('auth...')
      return new Promise((resolve, reject) => {
        let data
        data = {
          username: payload.username,
          password: payload.password,
        }
        let promise = axios.post(config.url + '/login_as_company_staff/', data)

        promise.then((response) => {
          if (isFailed(response)) {
            reject(response)
            return
          }

          // success
          context.commit('updateToken', response.data.token)

          context.commit('shared/updateUser', response.data.data, {root: true})


          resolve(response)
        })
        promise.catch((e) => {
          reject(e)
        })
      })
    },
    init (context, payload) {
      // this function triggers each time we visit company-select page
      context.commit('content/initContent', {dummy: true}, {root: true})
      context.commit('shared/setUsers', null, {root: true})
      context.dispatch('shared/loadFeatureFlags', {dummy: true}, {root: true})
      let token = context.state.token
      return new Promise((resolve) => { // after login init done resolve promise in ANY case
        axios.post(config.url + '/get_carrier_user/', { // recheck token
          token,
        }).then(
          (response) => {
            if (isFailed(response)) {
              context.commit('updateToken', null)
            }
            context.commit('shared/updateUser', response.data.data, {root: true})
            resolve()
          },
          (response) => {
            context.commit('updateToken', null)
            resolve()
          },
        )
      })
    },
  },
  getters: {},
}

export default loginModule
